import React from 'react';

interface Version {
  version: string;
  date: string;
  changes: string[];
}

const versions: Version[] = [
  {
    version: "1.2.0",
    date: "3 ngày trước",
    changes: [
      "Cải thiện hiệu suất ứng dụng",
      "Thêm tính năng thông báo thông minh",
      "Sửa lỗi hiển thị trên một số thiết bị",
      "Tối ưu hóa giao diện người dùng"
    ]
  },
  {
    version: "1.1.5",
    date: "2 tuần trước",
    changes: [
      "Thêm tính năng chat nhóm",
      "Cải thiện bảo mật dữ liệu",
      "Sửa lỗi đăng nhập bằng Google"
    ]
  }
];

const VersionHistory: React.FC = () => {
  return (
    <section className="bg-white rounded-2xl shadow-lg p-6 mb-8">
      <h2 className="text-2xl font-bold text-black mb-6">Có gì mới</h2>
      <div className="space-y-4">
        {versions.map((version, index) => (
          <div key={version.version} className={index > 0 ? "border-t border-gray-100 pt-4" : ""}>
            <div className="flex items-center justify-between mb-2">
              <span className="font-semibold text-black">Phiên bản {version.version}</span>
              <span className="text-gray-600 text-sm">{version.date}</span>
            </div>
            <ul className="text-black space-y-1 text-sm">
              {version.changes.map((change, changeIndex) => (
                <li key={changeIndex}>• {change}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VersionHistory;
